<template>
<div>
  <v-card elevation="0" class="mt-4">
    <v-row >
      <v-col  md="1" class="mrc-text-12-bold text-left">
        ID
      </v-col>
      <v-col  md="2" class="mrc-text-12-bold text-left">
        Booking ID
      </v-col>
      <v-col  md="3" class="mrc-text-12-bold text-left">
        Pickup Time
      </v-col>
      <v-col  md="6" class="mrc-text-12-bold text-left">
        Pickup Location
      </v-col>
    </v-row>
  </v-card>
  <draggable
    :list="taxiFollowOnJobs"
    :disabled="false"
    class="list-group"
    ghost-class="ghost"
    :move="checkMove"
    @start="dragging = true"
    @update="dragged = true"
    @end="dragging = false"
  >
    <v-card
      v-for="(item, index) in taxiFollowOnJobs"
      :key="item.id"
      class="draggable-row my-2"
    >
      <v-row
      >
        <v-col md="1">
          {{ index+1 }}
        </v-col>
        <v-col md="2">
          <v-btn color="blue lighten-1" small class="px-0 mx-0" text @click="goToBooking(item.bookingId)">
            {{ item.bookingId }}
            <v-icon small>mdi-open-in-new</v-icon>
          </v-btn>
        </v-col>
        <v-col md="3">{{ item.pickupTime }}</v-col>
        <v-col md="6">{{ item.pickupLocation }}</v-col>
      </v-row>
    </v-card>
  </draggable>
  <v-divider></v-divider>
  <v-card class="text-center" color="grey lighten-3" elevation="0">
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn small :disabled="taxiFollowOnJobs.length && taxiFollowOnJobs.length <= 1 || !dragged" outlined color="indigo darken-1" class="white--text" @click="updateFollowOnJobsPriority">Update</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "TaxiFollowOnJobsList",
  components: {
    draggable
  },
  props: {
   taxi: {
     default: null,
     type: Object
   }
  },
  data () {
    return {
      dragging: false,
      originalOrder: [],
      dragged: false,
      desserts: [
        {
          name: 'Frozen Yogurt',
          calories: 159,
        },
        {
          name: 'Ice cream sandwich',
          calories: 237,
        },
        {
          name: 'Eclair',
          calories: 262,
        },
        {
          name: 'Cupcake',
          calories: 305,
        },
        {
          name: 'Gingerbread',
          calories: 356,
        },
        {
          name: 'Jelly bean',
          calories: 375,
        },
        {
          name: 'Lollipop',
          calories: 392,
        },
        {
          name: 'Honeycomb',
          calories: 408,
        },
        {
          name: 'Donut',
          calories: 452,
        },
        {
          name: 'KitKat',
          calories: 518,
        },
      ],
      draggedIndex: -1,
    }
  },
  computed: {
    taxiFollowOnJobs () {
      return this.$store.getters['followOnJob/getFollowOnJobsForTaxi']
    }
  },

  methods: {
    updateFollowOnJobsPriority () {
      let data =this.taxiFollowOnJobs.map((job, index) => {
        return {
          id: job.id,
          priority: index+1
        }
      })
      console.log("priority ordered data", data )
      this.$store.dispatch('followOnJob/updateFollowOnJobsPriority', data)
    },
    checkMove: function(e) {
      window.console.log("Future index: " + e.draggedContext.futureIndex);
    },
    
    goToBooking(id) {
      return window.open('/bookings/' + id, '_blank')
    },
    fetchFollowOnJobsForTaxi () {
      if (this.taxi != null) {
        this.$store.dispatch('followOnJob/getFollowOnJobsForTaxi', this.taxi.id)
      }
    }
  },
  mounted() {
    this.fetchFollowOnJobsForTaxi()
  }
}
</script>

<style>
.draggable-row {
  cursor: move;
}
</style>